<script lang="ts">
	import type { Device } from 'src/types/Device';
	import type { DeviceStatusG2 } from 'src/types/DeviceStatusG2';
	import type { DeviceSettingsG2 } from 'src/types/DeviceSettings';
	import LiveStreamView from '../CameraPlayer/LiveStreamView.svelte';
	import LastRecordings from './LastRecordings.svelte';
	import RecordingKeyPrompt from '../CameraPlayer/RecordingKeyPrompt.svelte';
	import RecordingSetupPrompt from '../CameraPlayer/RecordingSetupPrompt.svelte';
	import CameraCloudStoragePromoBanner from 'src/components/Settings/CameraCloudStorage/CameraCloudStoragePromoBanner.svelte';
	import { ensureDeviceEncryption } from '../helpers/recording-key-management';
	import { real_id } from 'src/helpers/interface_helpers';

	export let device: Device, statuses, status: DeviceStatusG2, settings: DeviceSettingsG2;

	let lastEnsuredId = '';

	// Resolve the device key up-front, else start setup/unlock; gated so it runs once per device id.
	$: if (device?.id && real_id(device.id) !== lastEnsuredId) {
		lastEnsuredId = real_id(device.id);
		ensureDeviceEncryption(device);
	}
</script>

<div class="flex-full-height flex-column gap-m">
	<LiveStreamView {device} {status} {settings} />
	<LastRecordings {device} deviceId={device.id} />
	<CameraCloudStoragePromoBanner deviceId={device?.id} />
</div>

<RecordingKeyPrompt {device} />
<RecordingSetupPrompt {device} />
